import React, { useState } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { ChevronDown, ChevronUp } from "lucide-react-native";

const ExpandableText = ({ text, style }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const displayText = isExpanded ? text : text.slice(0, 20);

  return (
    <View style={{ flexDirection: "row" }}>
      <Text style={style}>{displayText}</Text>
      {!isExpanded && <Text>...</Text>}
      <TouchableOpacity onPress={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? (
          <ChevronUp width={20} height={20} stroke="#666" />
        ) : (
          <ChevronDown width={20} height={20} stroke="#666" />
        )}
      </TouchableOpacity>
    </View>
  );
};

export default ExpandableText;
